// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"87193f873fac3551","5285":"82cb02d59664b5e8"}[chunkId] + ".css";
};